import { FC } from "react";
import { Box } from "@mui/material";

interface CustomDividerProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  opacity?: number;
  mx?: number | string;
}

const CustomDivider: FC<CustomDividerProps> = ({
  width = "1px",
  height = 12,
  color = "#7D8690",
  opacity = 1,
  mx = 1,
}) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        width,
        height,
        backgroundColor: color,
        opacity,
        mx,
        flexShrink: 0,
      }}
    />
  );
};

export default CustomDivider;
